export function Acres({ acres, precision = 2 }) {
  return acres
    ? Number(acres).toLocaleString('en-US', {
        maximumFractionDigits: precision,
      })
    : null;
}
